<template>
  <v-chip-group
    mandatory
    @change="updateAndNotifyParent"
    active-class="success--text"
  >
    <v-chip
      v-for="forma in formasDePago"
      :key="forma.code"
      :class="getChipClass(forma)"
    >
      <v-icon v-show="showIcon(forma)" class="mr-2" small>mdi-check</v-icon>
      {{ forma.name }}
    </v-chip>
  </v-chip-group>
</template>
<script>
import cobrarMixin from "../mixins/mixin-cobrar";
export default {
  name: "PaymentMethodSelector",
  mixins: [cobrarMixin],
  methods: {
    showIcon(method) {
      return method.code == this.formaPago.code;
    },
    getChipClass(method) {
      return method.code == this.formaPago.code
        ? ""
        : "text-caption grey--text darken-1";
    },
    updateAndNotifyParent(methodIDX) {
      this.setPaymentMethod(methodIDX);
      this.$emit("selectionChanged", methodIDX);
    },
  },
};
</script>